import {
    Breadcrumbs,
    ClickAwayListener,
    Grow,
    Link,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Stack,
    TablePagination,
    Typography

} from "@mui/material";

import RefreshButton from "../../../../../common/components/refresh_button";
import FormContainer from "../../../../../common/components/form_container";
import { BackButton } from "../../../../../common/components/back_button";
import BottomBar from "../../../../../common/components/bottom_bar";
import PrimaryButton from "../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import { ChangeHistoryModal } from "../../../../../common/modals/change_history_modal";
import DefaultFormInput from "../../../../../common/components/default_form_input";
import { Link as LinkTo } from "react-router";
import { PageTopBar, ThreeSlotLayout } from "../../../../../common/components/page_top_bar";
import { useClientesCadastroViewModel } from "../../viewModels/clientes_cadastro_view_model";
import { FormCPFMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_cpf_masked_input";
import { FormCNPJMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_cnpj_masked_input";
import { FormPhoneMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_phone_masked_input";
import { useMemo } from "react";
import { GenerateClienteArquivosListaColumns } from "./columns/generateClientesArquivo";
import { GenerateClientesCentroCustoListaColumns } from "./columns/generateClientesCentroCusto";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { ClienteArquivoLista } from "../../../domain/models/clienteArquivoLista";
import { FormDatePickerInput } from "../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { ClienteCentroCustoLista } from "../../../domain/models/clienteCentroCustoLista";
import { ClienteCentroCustoModal } from "./components/cliente_centro_custo_modal";
import { ClienteArquivoModal } from "./components/cliente_arquivo_modal";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { FormMaskedInput } from "../../../../../common/components/masked_inputs/react_forms/form_masked_input";

export const ClientesCadastro = () => {

    const viewModel = useClientesCadastroViewModel();

    const centroCustoClienteColumnsDefinition = useMemo(() => {
        return GenerateClientesCentroCustoListaColumns({
            onActionEdit: viewModel.handleClienteCentroCustoModalOpenState,
            onActionDelete: viewModel.handleClienteCentroCustoDeleteOpenState,
        });
    }, [viewModel.handleClienteCentroCustoModalOpenState, viewModel.handleClienteCentroCustoDeleteOpenState]);

    const clienteArquivosColumnsDefinition = useMemo(() => {
        return GenerateClienteArquivosListaColumns({
            onActionEdit: viewModel.handleClienteArquivoModalOpenState,
            onActionDelete: viewModel.handleClienteArquivoDeleteOpenState,
            onActionDownload: viewModel.handleDownloadClienteArquivo,
        });
    }, [
        viewModel.handleClienteArquivoModalOpenState,
        viewModel.handleClienteArquivoDeleteOpenState,
        viewModel.handleDownloadClienteArquivo,
    ]);


    const tabelaClienteCentroCusto = useMemo(() => {
        return (
            <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                <StyledDataGrid
                    tableName="cliente_centro_custo"
                    disableColumnMenu={false}
                    getRowId={(row: ClienteCentroCustoLista) => row.idClienteCentroCusto}
                    columns={centroCustoClienteColumnsDefinition}
                    loading={viewModel.loading}
                    autoHeight={true}
                    rows={viewModel.clienteCentroCustoLista}
                    rowCount={viewModel.clienteCentroCustoLista.length}
                    pageSizeOptions={[5]}
                    paginationMode="server"
                    paginationModel={{
                        page: viewModel.pagination.clienteCentroCusto.page,
                        pageSize: viewModel.pagination.clienteCentroCusto.rowsPerPage,
                    }} />

                <TablePagination
                    component="div"
                    count={viewModel.pagination.clienteCentroCusto.totalItems}
                    page={viewModel.pagination.clienteCentroCusto.page - 1}
                    rowsPerPageOptions={[5]}
                    onPageChange={(_, p) => viewModel.handleClienteCentroCustoPageChange(p)}
                    rowsPerPage={viewModel.pagination.clienteCentroCusto.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleClienteCentroCustoRowsPerPageChange(parseInt(e.target.value))} />
            </div>
        );
    }, [
        viewModel,
        centroCustoClienteColumnsDefinition,
    ]);

    const tabelaClienteArquivo = useMemo(() => {
        return (
            <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                <StyledDataGrid
                    tableName="centro_custo_cadastro_2"
                    disableColumnMenu={false}
                    getRowId={(row: ClienteArquivoLista) => row.idClienteArquivo}
                    columns={clienteArquivosColumnsDefinition}
                    loading={viewModel.loading}
                    autoHeight={true}
                    rows={viewModel.clienteArquivoLista}
                    rowCount={viewModel.clienteArquivoLista.length}
                    pageSizeOptions={[5]}
                    paginationMode="server"
                    paginationModel={{
                        page: viewModel.pagination.clienteArquivos.page,
                        pageSize: viewModel.pagination.clienteArquivos.rowsPerPage,
                    }} />

                <TablePagination
                    component="div"
                    count={viewModel.pagination.clienteArquivos.totalItems}
                    page={viewModel.pagination.clienteArquivos.page - 1}
                    rowsPerPageOptions={[5]}
                    onPageChange={(_, p) => viewModel.handleClienteArquivoPageChange(p)}
                    rowsPerPage={viewModel.pagination.clienteArquivos.rowsPerPage}
                    onRowsPerPageChange={(e) => viewModel.handleClienteArquivoRowsPerPageChange(parseInt(e.target.value))} />

            </div>
        );
    }, [
        viewModel,
        clienteArquivosColumnsDefinition,
    ]);



    return (
        <>
            <PageTopBar>
                <ThreeSlotLayout
                    rightSlot={
                        <div className="flex flex-row w-full justify-end gap-2">
                            <BackButton onClick={() => viewModel.handlePageBack()} />
                            <div>
                                <Stack direction="row" spacing={2}>


                                    <div className="w-[12rem]">
                                        <PrimaryButton
                                            ref={viewModel.menuRef}
                                            id="composition-button"
                                            aria-controls={viewModel.openMenu ? "composition-menu" : undefined}
                                            aria-expanded={viewModel.openMenu ? "true" : undefined}
                                            aria-haspopup="true"
                                            onClick={viewModel.handleToggleMenu}
                                            buttonColor="primary-green"
                                        >
                                            Opções
                                        </PrimaryButton>
                                        <Popper
                                            style={{ zIndex: 10000 }}
                                            open={viewModel.openMenu}
                                            anchorEl={viewModel.menuRef.current}
                                            placement="bottom-start"
                                            transition
                                            disablePortal
                                        >
                                            {({ TransitionProps, placement }) => (
                                                <Grow
                                                    {...TransitionProps}
                                                    style={{
                                                        transformOrigin:
                                                            placement === "bottom-start" ? "left top" : "left bottom"
                                                    }}
                                                >
                                                    <Paper>
                                                        <ClickAwayListener onClickAway={viewModel.handleCloseMenu}>
                                                            <MenuList
                                                                autoFocusItem={viewModel.openMenu}
                                                                id="composition-menu"
                                                                aria-labelledby="composition-button"
                                                                onKeyDown={viewModel.handleListKeyDown}
                                                            >
                                                                <MenuItem onClick={() => viewModel.handleNewClientes()}>Novo Cliente</MenuItem>
                                                                <MenuItem onClick={() => viewModel.handleClienteDeleteOpenState(true)}> Excluir </MenuItem>
                                                            </MenuList>
                                                        </ClickAwayListener>
                                                    </Paper>
                                                </Grow>
                                            )}
                                        </Popper>
                                    </div>
                                </Stack>
                            </div>
                        </div>
                    }
                />
            </PageTopBar>

            <form className="pb-8" onSubmit={viewModel.handleSalvarClientes}>
                <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
                    <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
                        <Link underline="hover" color="inherit">
                            Comercial
                        </Link>
                        <Link underline="hover" color="inherit" component={'span'}>
                            <LinkTo to="/Clientes_lista">Clientes Lista</LinkTo>
                        </Link>
                        <Typography className="text-primary-green">
                            Cadastro Clientes
                        </Typography>
                    </Breadcrumbs>

                    <div className="flex justify-between items-center flex-col md:flex-row gap-6 md:gap-0">
                        <div className="flex gap-2 items-center w-full">
                            <h1 className="text-3xl font-medium text-black dark:text-white">
                                Cliente Cadastro
                            </h1>
                            <RefreshButton onClick={() => { }} />
                        </div>
                    </div>

                    {/* STATUS */}
                    <div className="w-full bg-light-mode-2 dark:bg-dark-mode-2 p-4 rounded-[4px] border-[1px] border-border-light-mode dark:border-border-dark-mode mb-4">
                        {/* INFORMAÇÕES GERAIS */}
                        <FormContainer title="Informações Gerais" arrangement="fullRow" border={false}>
                            <div className="flex flex-col items-center w-full gap-4">
                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='nomeFantasia'
                                            required={true}
                                            label='Nome do Cliente'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                    <div className="w-[20%]">
                                        <FormCPFMaskedInput
                                            name='cpf'
                                            required={false}
                                            label='CPF'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}

                                        />
                                    </div>

                                    <div className="w-[30%]">
                                        <FormDatePickerInput
                                            name='dataNascimento'
                                            required={false}
                                            label='Data Nascimento'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente} />
                                    </div>

                                </div>


                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='nomeFantasia2'
                                            required={false}
                                            label='Nome do Cliente - 02'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>
                                    <div className="w-[20%]">
                                        <FormCPFMaskedInput
                                            name='cpf2'
                                            required={false}
                                            label='CPF - 02'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}

                                        />
                                    </div>
                                    <div className="w-[30%]">
                                        <FormDatePickerInput
                                            name='dataNascimento2'
                                            required={false}
                                            label='Data Nascimento - 02'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente} />
                                    </div>

                                </div>


                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[70%]">
                                        <DefaultFormInput
                                            name='razaoSocial'
                                            required={false}
                                            label='Razão Social'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[70%]">
                                        <DefaultFormInput
                                            name='email'
                                            required={false}
                                            label='Email'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />

                                    </div>

                                    <div className="w-[30%]">
                                        <FormCNPJMaskedInput
                                            name='cnpj'
                                            required={false}
                                            label='CNPJ'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}

                                        />
                                    </div>

                                </div>
                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[60%]">
                                        <DefaultFormInput
                                            name='contato'
                                            required={false}
                                            label='Contato'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                    <div className="w-[20%]">
                                        <FormPhoneMaskedInput
                                            name='telefoneFixo'
                                            type='fixo'
                                            label='Tel. Fixo'
                                            reactHookForm={viewModel.hookFormCliente} />
                                    </div>

                                    <div className="w-[20%]">
                                        <FormPhoneMaskedInput
                                            name='telefoneCelular'
                                            type='movel'
                                            label='Tel. Celular'
                                            reactHookForm={viewModel.hookFormCliente} />
                                    </div>
                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='incricaoMunicipal'
                                            required={false}
                                            label='Inscrição Municipal'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                    <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='atividade'
                                            required={false}
                                            label='Atividade'
                                            readOnly={false}
                                            reactHookForm={viewModel.hookFormCliente}

                                        />
                                    </div>

                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[70%]">
                                        <DefaultFormInput
                                            name='incricaoEstadual'
                                            required={false}
                                            label='Inscrição Estadual'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>
                                    <div className="w-[30%]">
                                        <FormDatePickerInput
                                            name='dataCadastro'
                                            required={false}
                                            label='Data Cadastro'
                                            readOnly={true}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-full">
                                        <DefaultFormInput
                                            name='obsCliente'
                                            required={false}
                                            multiline={true}
                                            rows={5}
                                            label='Observação'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                </div>

                            </div>
                        </FormContainer>
                        {/* ENDERECO */}
                        <FormContainer title="Endereço" arrangement="fullRow" border={false}>
                            <div className="flex flex-col items-center w-full gap-4">
                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[50%]">
                                        <FormMaskedInput
                                            name='cep'
                                            label={"CEP"}
                                            unmask={false}
                                            mask="00.000-000"
                                            maskPlaceholder="__.___-___"
                                            reactHookForm={viewModel.hookFormCliente}
                                            onChange={(cep) => {
                                                const normalizedCep = cep.trim().replaceAll('_', '');
                                                const requiredSize = 'xx.xxx-xxx';

                                                if (!viewModel.onLoadCepSkiper.current) {
                                                    if (normalizedCep.length === 0 || normalizedCep.length === requiredSize.length) {
                                                        viewModel.handleLoadCep(cep);
                                                    }
                                                }
                                                viewModel.onLoadCepSkiper.current = false;
                                            }} />
                                    </div>

                                    <div className="w-[30%]">
                                        <DefaultFormInput
                                            name='cidade'
                                            required={false}
                                            label='Cidade'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>
                                    <div className="w-[20%]">
                                        <DefaultFormInput
                                            name='uf'
                                            required={false}
                                            label='Estado'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[50%]">
                                        <DefaultFormInput
                                            name='rua'
                                            required={false}
                                            label='Rua/Alameda'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                    <div className="w-[30%]">
                                        <DefaultFormInput
                                            name='bairro'
                                            required={false}
                                            label='Bairro'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>
                                    <div className="w-[20%]">
                                        <DefaultFormInput
                                            name='numero'
                                            required={false}
                                            label='Número'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                </div>

                                <div className="flex flex-row gap-4 w-full justify-between">
                                    <div className="w-[70%]">
                                        <DefaultFormInput
                                            name='apartamento'
                                            required={false}
                                            label='Complemento'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                    <div className="w-[30%]">
                                        <DefaultFormInput
                                            name='pais'
                                            required={false}
                                            label='País'
                                            readOnly={viewModel.saving}
                                            reactHookForm={viewModel.hookFormCliente}
                                        />
                                    </div>

                                </div>
                            </div>
                        </FormContainer>

                        {/* CENTRO DE CUSTO */}
                        {
                            viewModel.clienteSelectedId &&
                            <>
                                <div className="w-full flex flex-row justify-between items-center mt-8 mb-2">
                                    <h1 className="font-bold text-black dark:text-white text-3xl">Centro de Custo</h1>
                                    <div>
                                        <PrimaryButton
                                            startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                            sx={{ px: 2 }}
                                            onClick={() => viewModel.handleClienteCentroCustoModalOpenState(null, true)}>
                                            Novo Item
                                        </PrimaryButton>
                                    </div>
                                </div>
                                {tabelaClienteCentroCusto}
                            </>
                        }


                        {/* ARQUIVOS DIVERSOS */}

                        {
                            viewModel.clienteSelectedId &&
                            <>
                                <div className="w-full flex flex-row justify-between items-center mt-8 mb-2">
                                    <h1 className="font-bold text-black dark:text-white text-3xl">Arquivos Diversos</h1>
                                    <div>
                                        <PrimaryButton
                                            startIcon={<DynamicIcon nameIcon="AddRounded" size={25} className="text-white" />}
                                            sx={{ px: 2 }}
                                            onClick={() => viewModel.handleClienteArquivoModalOpenState(null, true)}>
                                            Novo Item
                                        </PrimaryButton>
                                    </div>
                                </div>
                                {tabelaClienteArquivo}
                            </>
                        }
                    </div>

                </div>

                <BottomBar>
                    <div className="w-full h-full flex justify-between items-center p-4 gap-6">
                        <div>
                            <div>
                                <PrimaryButton
                                    buttonColor="yellow"
                                    onClick={() => viewModel.handleOpenChangeHistory(viewModel.cliente?.idCliente ?? null, null)}>
                                    <span className="text-xs">
                                        Historico de alterações
                                    </span>
                                </PrimaryButton>
                            </div>

                        </div>

                        <div className="w-full h-full flex justify-end items-center p-4 gap-6">

                            <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                                <h1 className="text-sm text-black dark:text-white" onClick={() => viewModel.handlePageBack()}>
                                    Cancelar
                                </h1>
                            </div>

                            <div className="w-40">
                                {viewModel.saving ? (
                                    <PrimaryButton>Salvando...</PrimaryButton>
                                ) : (
                                    <PrimaryButton
                                        type="submit"
                                        startIcon={<DynamicIcon nameIcon="CheckRounded" size={25} className="text-white" />}
                                    >
                                        Salvar
                                    </PrimaryButton>
                                )}
                            </div>
                        </div>
                    </div>
                </BottomBar>

            </form >


            {/* CLIENTE */}
            <DeleteDialog
                open={viewModel.openDeleteClienteModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleClienteDeleteOpenState(false)}
                title={`Você realmente deseja excluir este cliente?`}
                onDelete={viewModel.handleConfirmarDeletarCliente}

            />

            {/* CLIENTE CENTRO CUSTO */}
            <DeleteDialog
                open={viewModel.openDeleteClienteCentroCustoModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleClienteCentroCustoDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este centro de custo?`}
                onDelete={viewModel.handleConfirmarDeletarClienteCentroCusto}
            />

            {/* CLIENTE ARQUIVO */}
            <DeleteDialog
                open={viewModel.openDeleteClienteArquivoModal}
                saving={viewModel.saving}
                onClose={() => viewModel.handleClienteArquivoDeleteOpenState(null, false)}
                title={`Você realmente deseja excluir este arquivo?`}
                onDelete={viewModel.handleConfirmarDeletarClienteArquivo}
            />

            <ChangeHistoryModal
                changeHistoryHandler={viewModel.changeHistory}
            />

            <ClienteCentroCustoModal
                open={viewModel.openClienteCentroCustoModal}
                saving={viewModel.saving}
                selectedClienteCentroCusto={viewModel.clienteCentroCusto ?? null}
                onOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onClose={() => viewModel.handleClienteCentroCustoModalOpenState(null, false)}
                onSubmit={viewModel.handleSalvarClienteCentroCusto}
            />

            <ClienteArquivoModal
                open={viewModel.openClienteArquivoModal}
                saving={viewModel.saving}
                selectedClienteArquivo={viewModel.clienteArquivo ?? null}
                onClose={() => viewModel.handleClienteArquivoModalOpenState(null, false)}
                onSubmit={viewModel.handleSalvarClienteArquivo}
                onOpenChangeHistory={viewModel.handleOpenChangeHistory}
                onDeleteFile={viewModel.handleDeleteFile}
                onDownload={viewModel.handleDownloadClienteArquivo}

            />

        </>
    );
};
